<input type="text"
       class="form-control text-ellipsis"
       [ngModel]="searchText"
       [ngModelOptions]="{standalone: true}"
       (ngModelChange)="onSearchTextChange($event)"
       [ngbTypeahead]="search"
       [inputFormatter]="formatPrediction"
       [resultFormatter]="formatPrediction"
       [placeholder]="placeholder | translate"
       [title]="address?.place || ''"
       container="body"
       popupClass="address-autocomplete-popup"
       (selectItem)="onSelectItem($event)">
